import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { fetchCrearOficina } from '../../../peticiones_API/PeticionesGestionPersonasOficinas';
import ErrorForm from '../eventos/avisos/Alerta';
import { handleChangeErrors, handleSubmitErrorsOficinas, todosDatosCorrectos } from '../../validacion/ValidationFormDepartamento';
import { DatosCorrectosOficina, ServerNoCreoOficina, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import { ToastContainer, toast } from "react-toastify";
import { getProvincias, getMunicipios, buscarDireccionPorCP, buscarCPPorPoblacion, buscarProvinciaPorNombre } from '../../../utils/direccionesUtils';
import useFormPersistence from '../../../hooks/useFormPersistence';


const FormCrearOficina = ({ }) => {

const initialFormState = {
        nombre: '',
        direccion: '',
        cp: '',
        provincia: '',
        poblacion: '',
    };

const [formData, setFormData, clearFormDraft] = useFormPersistence(
    'crear_oficina',
    initialFormState
);

    const [provinciaId, setProvinciaId] = useState(null);
    const [municipios, setMunicipios] = useState([]);
    const provincias = getProvincias();

    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
        direccion: "Debes insertar una direccion",
        cp: "Debes insertar un codigo postal",
        provincia: "Debes insertar una provincia",
        poblacion: "Debes insertar una poblacion",
    };

    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: null,
        direccion: null,
        cp: null,
        provincia: null,
        poblacion: null,
    });

    let [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);

    const [errorEnviarForm, setErrorEnviarForm] = useState({
        oficinaDuplicado: null,
        refDuplicado: null

    });

    useEffect(() => {
        const nuevosMunicipios = getMunicipios(provinciaId);
        setMunicipios(nuevosMunicipios);
    }, [provinciaId]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setFormCompletado(null);
        setErrorEnviarForm({ oficinaDuplicado: null, refDuplicado: null });
        setEstadosActualizados(false);
        
        handleSubmitErrorsOficinas(formData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
    };

    useEffect (() => {

        if (estadosActualizados) {

            let validacionTodosDatos = todosDatosCorrectos(formData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    try {

                        const response = await fetchCrearOficina(formData);
                        clearFormDraft();
                        setFormCompletado(true);

                    } catch (error) {

                        console.error(error);

                        if (error?.response?.data?.error === 'REGISTRO_DUPLICADO') {
                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, oficinaDuplicado: true }));
                        }
                        setFormCompletado(false);

                    }
                } else {
                    toast.error("Faltan campos por rellenar")
                }
                setEstadosActualizados(false);
            })();
        }
    }, [estadosActualizados, formData, estadoCampoReque])

    const handleChange = (event) => {
        const { name, value } = event.target;

        setFormData(prev => ({ ...prev, [name]: value }));

        if (name === 'cp' && value.length === 5) {
            const address = buscarDireccionPorCP(value);
            if (address) {
                setFormData(prev => ({
                    ...prev,
                    ...address,
                    cp: value
                }));
                setProvinciaId(address.provinciaId);
            }
        }

        if (name === 'provincia') {
            const provId = buscarProvinciaPorNombre(value);
            setProvinciaId(provId);
            setFormData(prev => ({ ...prev, provincia: value, poblacion: '', cp: '' }));
        }

        if (name === 'poblacion') {
            const cp = buscarCPPorPoblacion(formData.provincia, value);
            if (cp) {
                setFormData(prev => ({ ...prev, cp: cp }));
            }
        }

        if (name in estadoCampoReque) {
            handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }
    }

    return ( 
        <>
            <Form>
                <CabeceraForm>
                    <Titulo texto="CREAR UNA OFICINA" />
                </CabeceraForm>

                <Container>
                    <ToastContainer/>
                    <Col>
                        <Row md="3">
                            <Form.Group className="mb-12">
                                <TituloCategoria>Nombre <span>*</span></TituloCategoria>
                                <Form.Control type='text' name='nombre' value={formData.nombre || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                            </Form.Group>

                            <Form.Group className="mb-12">
                                <TituloCategoria>Telefono</TituloCategoria>
                                <Form.Control type='text' name='telefono' value={formData.telefono || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.telefono} estadoAlerta={estadoCampoReque.telefono} />
                            </Form.Group>

                            <Form.Group className="mb-12">
                                <TituloCategoria>Email</TituloCategoria>
                                <Form.Control type='mail' name='email' value={formData.email || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.email} estadoAlerta={estadoCampoReque.email} />
                            </Form.Group>
                        </Row>

                        <Row md="3">
                            <Form.Group className="mb-12">
                                <TituloCategoria>Direccion <span>*</span></TituloCategoria>
                                <Form.Control type='text' name='direccion' value={formData.direccion || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.direccion} estadoAlerta={estadoCampoReque.direccion} />
                            </Form.Group>

                            <Form.Group className='mb-12'>
                                <TituloCategoria>Provincia <span>*</span></TituloCategoria>
                                <Form.Select value={formData.provincia || ''} name="provincia" onChange={handleChange}>
                                    <option value=""></option>
                                    {provincias.sort((a, b) => a.localeCompare(b)).map((provincia, index) => (
                                        <option key={index} value={provincia}>
                                            {provincia}
                                        </option>
                                    ))}
                                </Form.Select>
                                <ErrorForm mensaje={camposRequeridos.provincia} estadoAlerta={estadoCampoReque.provincia} />
                            </Form.Group>

                            <Form.Group className='mb-12'>
                                <TituloCategoria>Población <span>*</span></TituloCategoria>
                                <Form.Select value={formData.poblacion || ''} name="poblacion" onChange={handleChange}>
                                    <option value=""></option>
                                    {municipios.map((poblaciones, index) => (
                                        <option key={index} value={poblaciones.name}>
                                            {poblaciones.name}
                                        </option>
                                    ))}
                                </Form.Select>
                                <ErrorForm mensaje={camposRequeridos.poblacion} estadoAlerta={estadoCampoReque.poblacion} />
                            </Form.Group>
                        </Row>

                        <Row md="3">
                            <Form.Group className="mb-12">
                                <TituloCategoria>Codigo Postal <span>*</span></TituloCategoria>
                                <Form.Control type='number' name='cp' value={formData.cp || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.cp} estadoAlerta={estadoCampoReque.cp} />
                            </Form.Group>

                            <Form.Group className="mb-12">
                                <TituloCategoria>Horario</TituloCategoria>
                                <Form.Control as="textarea" rows={5} name='horario' value={formData.horario || ''} onChange={handleChange} placeholder={`Ej:
Lunes-Viernes: 08:00-14:00
Sabados: 09:00-13:00
Domingos: Cerrado`} />
                                <ErrorForm mensaje={camposRequeridos.horario} estadoAlerta={estadoCampoReque.horario} />
                            </Form.Group>
                        </Row>

                        <Row className="mt-4">
                            <ContenedorBotones>
                                <Boton
                                    bonificados="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                    form="true"
                                >
                                    Crear Oficina
                                </Boton>
                                <Boton
                                    grande="true"
                                    to="/gestionpersonas/oficinas"
                                >
                                    Cancelar
                                </Boton>
                            </ContenedorBotones>
                        </Row>
                    </Col>
                </Container>
            </Form>
            <DatosCorrectosOficina envioActivado={formCompletado} />
            <DatosIncorrectos envioActivado={formCompletado} duplicado={errorEnviarForm.oficinaDuplicado} />
            <ServerNoCreoOficina envioActivado={formCompletado === false && !errorEnviarForm.oficinaDuplicado} />
        </>
     );
}

const CabeceraForm = styled.div`
    margin: 2% 0% 2% 35%;
`

const ContenedorBotones = styled.div`
    margin-top: 30%;
`

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }
`
 
export default FormCrearOficina;